/* eslint-disable no-lonely-if */

/**
 * This is issue-details script.js file
 */

export default {

    /**
     * Nombre del componente
     */
    name : 'ModalRdFileDownload',

    /**
     * Props de entrada
     */
    props : {
        action : {
            type: Function,
            required: true
        },
        iconClass : {
            type : Array,
            required: false
        },
        disabled : {
            type: Boolean,
            required: false
        }
    },

    /**
     * @override
     */
    data() {
        return {
            error: null,
            success: false,
            downloading: false
        };
    },

    computed: {
        /**
         * Clases del icono
         * @return {Array} listado de clases
         */
        iClass() {
            if (this.error) {
                return [ ...this.iconClass, 'color-error' ];
            } else if (this.success) {
                return [ ...this.iconClass, 'color-brand' ];
            } else if (this.disabled) {
                return [ ...this.iconClass, 'color-light' ];
            } else {
                return this.iconClass;
            }
        }
    },

    methods: {
        /**
         * Ejecuta la descarga
         */
        download() {
            this.downloading = true;
            this.success = false;
            this.error = null;
            this.action()
                .then(() => {
                    this.success = true;
                    this.error = null;
                    this.downloading = false;
                })
                .catch(err => {
                    switch (err.message) {
                        case 'No content':
                            this.success = false;
                            this.error = 'No se encontraron registros.';
                            this.downloading = false;
                            break;
                        default:
                            this.success = false;
                            this.error = err;
                            this.downloading = false;
                            break;
                    }

                });
        }
    }

};
